
/**
 * Stack - Product Page Overrides
 * Reorganizes product info elements for custom layout
 */

(function() {
  'use strict';

  const initProductLayout = () => {
    const productInfo = document.querySelector('.product__info-container');
    if (!productInfo) return;

    // Check if already processed
    if (productInfo.querySelector('.stack-product-bottom-row')) return;

    // =============================================
    // 1. Variant badge next to inventory
    // =============================================
    const inventory = productInfo.querySelector('.product__inventory');
    const variantPicker = productInfo.querySelector('.product-parameters');

    if (inventory && variantPicker) {
      // Get the selected variant value(s) from radio buttons or selects
      const checkedRadios = variantPicker.querySelectorAll('input[type="radio"]:checked');
      const selects = variantPicker.querySelectorAll('select');

      const variantValues = [];

      checkedRadios.forEach(radio => {
        // Skip color swatches — only show non-color options like size
        const fieldset = radio.closest('fieldset');
        if (fieldset && !fieldset.classList.contains('product-form__controls--colors') && !fieldset.classList.contains('js-radio-colors')) {
          variantValues.push(radio.value);
        }
      });

      selects.forEach(select => {
        if (select.value) {
          variantValues.push(select.value);
        }
      });

      // Create variant badges and insert them into the inventory row
      if (variantValues.length > 0) {
        const badgesContainer = document.createElement('div');
        badgesContainer.className = 'stack-variant-badges';

        variantValues.forEach(val => {
          const badge = document.createElement('span');
          badge.className = 'stack-variant-badge';
          badge.textContent = val;
          badgesContainer.appendChild(badge);
        });

        inventory.appendChild(badgesContainer);
      }

      // Keep all variant fieldsets visible so users can change variants

      // Translate option labels (e.g. "Size" → "Tamaño")
      const optionLabels = variantPicker.querySelectorAll('.product-form__group-name');
      const translations = { 'size': 'Tamaño', 'color': 'Color' };
      optionLabels.forEach(label => {
        const text = label.textContent.trim().toLowerCase();
        if (translations[text]) {
          label.textContent = translations[text];
        }
      });
    }

    // Listen for variant changes to update the badge
    const variantRadios = productInfo.querySelector('variant-radios, variant-selects');
    if (variantRadios) {
      const rebuildBadges = () => {
        // Remove old badges anywhere in product info
        productInfo.querySelectorAll('.stack-variant-badges').forEach(el => el.remove());

        const inv = productInfo.querySelector('.product__inventory');
        if (!inv) return;

        const checkedRadios = variantRadios.querySelectorAll('input[type="radio"]:checked');
        const selects = variantRadios.querySelectorAll('select');
        const values = [];

        checkedRadios.forEach(radio => {
          const fieldset = radio.closest('fieldset');
          if (fieldset && !fieldset.classList.contains('product-form__controls--colors') && !fieldset.classList.contains('js-radio-colors')) {
            values.push(radio.value);
          }
        });

        selects.forEach(select => {
          if (select.value) values.push(select.value);
        });

        if (values.length > 0) {
          const container = document.createElement('div');
          container.className = 'stack-variant-badges';
          values.forEach(val => {
            const badge = document.createElement('span');
            badge.className = 'stack-variant-badge';
            badge.textContent = val;
            container.appendChild(badge);
          });
          inv.appendChild(container);
        }
      };

      variantRadios.addEventListener('change', rebuildBadges);

      // Observe inventory container for DOM replacement (Section Rendering API)
      const inventoryObserver = new MutationObserver(() => {
        const inv = productInfo.querySelector('.product__inventory');
        if (inv && !inv.querySelector('.stack-variant-badges')) {
          rebuildBadges();
        }
      });
      inventoryObserver.observe(productInfo, { childList: true, subtree: true });
    }

    // =============================================
    // 2. Bottom row: text_with_icon + share buttons
    // =============================================
    const textWithIcons = productInfo.querySelectorAll('.text_with_icon');
    const shareButtons = productInfo.querySelector('.share-buttons');

    if (textWithIcons.length === 0 && !shareButtons) return;

    // Create wrapper for bottom row
    const bottomRow = document.createElement('div');
    bottomRow.className = 'stack-product-bottom-row';

    // Create icons container
    const iconsContainer = document.createElement('div');
    iconsContainer.className = 'stack-product-icons';

    // Create social container
    const socialContainer = document.createElement('div');
    socialContainer.className = 'stack-product-social';

    // Move text_with_icon elements to icons container
    textWithIcons.forEach(el => {
      iconsContainer.appendChild(el);
    });

    // Move share buttons to social container
    if (shareButtons) {
      socialContainer.appendChild(shareButtons);
    }

    // Append containers to bottom row
    if (iconsContainer.children.length > 0) {
      bottomRow.appendChild(iconsContainer);
    }
    if (socialContainer.children.length > 0) {
      bottomRow.appendChild(socialContainer);
    }

    // Insert bottom row at the end of product info
    if (bottomRow.children.length > 0) {
      productInfo.appendChild(bottomRow);
    }
  };

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductLayout);
  } else {
    initProductLayout();
  }

  // Re-initialize on Shopify section load (for theme editor)
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.product__info-container')) {
      // Clean up before re-init
      const existing = event.target.querySelector('.stack-product-bottom-row');
      if (existing) existing.remove();
      const oldBadges = event.target.querySelector('.stack-variant-badges');
      if (oldBadges) oldBadges.remove();
      event.target.querySelectorAll('.stack-hidden').forEach(el => el.classList.remove('stack-hidden'));

      initProductLayout();
    }
  });
})();
